
import axios from "axios";
import { GET_LANDS_OWNED_BY_ADDRESS } from "../../../apollo/queries";
import { graphEndpoint } from "../../../helper/subgraphs";

const getAllLandsByWallet = async (wallet: string) => {
  try {
    const GET_LANDS_OWNED_BY_ADDRESS_ENDPOINT = graphEndpoint(true)
    const res = await axios.post(GET_LANDS_OWNED_BY_ADDRESS_ENDPOINT, {
      query: GET_LANDS_OWNED_BY_ADDRESS(wallet)
    });
    return res.data.data.landInfos;
  } catch (error) {
    return [];
  }
};

export const ShibYardService = {
  getAllLandsByWallet,
};
